<template>
  <div :class="divWidthChange" class="conteudoWidth fccObjetos">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row buttonsOptions">
      <div class="col-sm-12">
        <button
          v-b-tooltip.hover
          title="Adicionar Menu"
          @click="addMenu()"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="plus" />
        </button>
        <button
          v-b-tooltip.hover
          title="Voltar"
          @click="$router.push({ path: '/seguranca/aplicacoes' })"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="chevron-left" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <Tree :value="lstObjetos" class="divSearch" @drop="dragMenu()">
          <div
            slot-scope="{ node, index, path, tree }"
            class="treeCustom"
            :class="{ inactive: !node.objativo }"
          >
            <span v-if="node.children.length > 0" class="folder">
              <span @click="tree.toggleFold(node, path)" v-if="node">
                <font-awesome-icon icon="folder" size="sm" v-if="node.$folded" />
                <font-awesome-icon icon="folder-open" size="sm" v-if="!node.$folded" />
              </span>
            </span>
            <span @click="tree.toggleFold(node, path)" v-if="node">{{ node.text }}</span>
            <span class="buttonsTree">
              <a class="buttonOk" v-b-tooltip.hover title="Adicionar"
                ><font-awesome-icon icon="plus" size="sm" @click="addMenu(node.item)"
              /></a>
              <a class="buttonOk" v-b-tooltip.hover title="Editar"
                ><font-awesome-icon
                  icon="edit"
                  size="sm"
                  @click="editMenu(node.item, node.objparent)"
              /></a>
              <a class="buttonOk" v-b-tooltip.hover title="Transferir" v-if="path.length <= 1"
                ><font-awesome-icon
                  icon="share-square"
                  size="sm"
                  @click="transferindoMenu(node.item.objid)"
                />
              </a>
              <a
                class="buttonOk"
                v-b-tooltip.hover
                title="Excluir"
                @click="excluirMenu(node.item)"
                v-if="node.children.length === 0"
              >
                <font-awesome-icon icon="trash" size="sm" /> </a
            ></span>
          </div>
        </Tree>
      </div>
    </div>
    <fccModal
      centered
      idModal="editMenu"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="menu.objid === 0 ? adicionandoMenu() : editandoMenu()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <div class="col-sm-12">
            <input v-model="menu.objid" type="hidden" />
            <input v-model="objparent" type="hidden" />
            <fccInput extraClasses="inputLabel" v-model="menu.objnome" required>Nome</fccInput>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <fccInput extraClasses="inputLabel" v-model="objMetaDataArr.objlink">Link</fccInput>
          </div>
          <div class="col-sm-6">
            <fccInput extraClasses="inputLabel" v-model="objMetaDataArr.objicone" required
              >Ícone</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <label>Ativo</label><br />
            <toggle-button v-model="menu.objativo" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">Ações</div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6" v-for="item in listaAcao" :key="item.objacaopermID">
            <toggle-button
              @change="
                menu.objid === 0 ? modificaAcaoNew(item, $event) : modificaAcao(item, $event)
              "
              :value="
                lstPermissao.find(
                  (lista) =>
                    lista.objpermcodigo === item.objacaopermcodigo && lista.obpermativo === true
                )
                  ? true
                  : false
              "
            />
            <label>{{ item.objacaopermdescricao }}</label>
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import 'he-tree-vue/dist/he-tree-vue.css'
import { Tree, Draggable, Fold } from 'he-tree-vue'
import './assets/fccObjetos.scss'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Menu',
      titleModal: '',
      listaObjetos: {},
      baseUrlSeguranca: '',
      menu: {},
      objparent: '',
      listaAcao: [],
      objMetaDataArr: {},
      objetoFinal: [],
      permissoes: [],
      objetoReserva: [],
      objPermissoes: [],
      objetoId: ''
    }
  },
  components: { Tree: Tree.mixPlugins([Draggable, Fold]) },
  methods: {
    modificaAcaoNew: function (item, event) {
      const objPerm = {
        objpermid: 0,
        objpermcodigo: item.objacaopermcodigo,
        obpermativo: event.value
      }
      if (event.value === true) {
        this.objPermissoes.push(objPerm)
      } else {
        this.objPermissoes = this.objPermissoes.filter(
          (items) => items.objpermcodigo !== item.objacaopermcodigo
        )
      }
    },
    adicionandoPermissoes: function (id) {
      if (this.objPermissoes.length > 0) {
        for (var values of Object.values(this.objPermissoes)) {
          const objAdd = {
            objid: id,
            objpermcodigo: values.objpermcodigo,
            objpermid: 0,
            obpermativo: values.obpermativo
          }
          this.adicionandoAcao(objAdd)
        }
      }
    },
    modificaAcao: function (lst, event) {
      var itemLst = this.objPermissoes.filter(
        (items) => items.objpermcodigo === lst.objacaopermcodigo
      )
      const objLst = {
        objpermid: itemLst.length > 0 ? itemLst[0].objpermid : 0,
        objid: this.menu.objid,
        objpermcodigo: lst.objacaopermcodigo,
        obpermativo: event.value
      }
      if (itemLst.length > 0) {
        const objPermEdit = {
          objpermid: itemLst[0].objpermid,
          objpermcodigo: lst.objacaopermcodigo,
          obpermativo: event.value
        }
        this.objPermissoes = this.objPermissoes.filter(
          (items) => items.objpermcodigo !== lst.objacaopermcodigo
        )
        this.objPermissoes.push(objPermEdit)
        this.editandoAcao(objLst)
      } else {
        this.adicionandoAcao(objLst, 1)
      }
      this.listandoObjetos()
    },
    editandoAcao: function (item) {
      axios
        .put(
          this.baseUrlSeguranca + 'Objeto/alterarobjpermissao',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionandoAcao: function (item, id = null) {
      axios
        .post(
          this.baseUrlSeguranca + 'Objeto/adicionarobjpermissao',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (id !== null) {
            const objPermAdd = {
              objpermcodigo: item.objpermcodigo,
              objpermid: response.data,
              obpermativo: item.obpermativo
            }
            this.objPermissoes.push(objPermAdd)
          }
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    dragMenu: async function () {
      await this.listandoOrdem(this.objetoFinal)
      this.callToast(this.mensagensUpdate.editado, 'success')
    },
    excluirMenu: function (item) {
      this.callConfirm(this.mensagemExcluir, item.objnome).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'Objeto/excluir/' + item.objid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoObjetos()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    listandoOrdem: async function (lista) {
      this.objetoFinal = []
      for (var [key, listando] of Object.entries(lista)) {
        var lstCria = {
          objnome: listando.item.objnome,
          objid: listando.item.objid,
          objparent: 0,
          appid: listando.item.appid,
          objhashcode: listando.item.objhashcode,
          objativo: listando.item.objativo,
          objordem: listando.item.objordem,
          objtipID: 1
        }
        var lstCriaArray = {
          text: listando.item.objnome,
          $folded: listando.$folded,
          ordem: key,
          objparent: 0,
          objativo: listando.item.objativo,
          item: listando.item,
          children: []
        }
        this.editandoOrdem(lstCria)
        if (listando.children.length > 0) {
          for (var [keyNumber, lstParents] of Object.entries(listando.children)) {
            var lstChildren = await this.ordenaChildren(lstParents, lstCria, keyNumber)
            lstCriaArray.children.push(lstChildren)
          }
        }
        this.objetoFinal.push(lstCriaArray)
      }
    },
    ordenaChildren: function (lista, lstCria, key) {
      var lstFinal = {
        objativo: lista.item.objativo,
        objparent: lstCria.objid,
        objordem: key,
        objid: lista.item.objid,
        appid: lista.item.appid,
        objhashcode: lista.item.objhashcode,
        objnome: lista.item.objnome,
        objtipID: 1
      }
      var lstFinalArray = {
        text: lista.item.objnome,
        $folded: lista.$folded,
        objativo: lista.item.objativo,
        ordem: key,
        objparent: lstCria.objid,
        item: lista.item,
        children: []
      }
      this.editandoOrdem(lstFinal)
      if (lista.children.length > 0) {
        for (var [keyNumber, lstParents] of Object.entries(lista.children)) {
          var lstChildren = this.ordenaChildren(lstParents, lstFinal, keyNumber)
          lstFinalArray.children.push(lstChildren)
        }
      }
      return lstFinalArray
    },
    editandoOrdem: function (menu) {
      axios
        .put(this.baseUrlSeguranca + 'Objeto/Alterar', menu, this.dadosLoginSession.fccTokenHeaders)
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    addMenu: function (item = null) {
      this.titleModal = 'Adicionar Menu'
      this.menu = {}
      this.objparent = item === null || item === undefined ? 0 : item.objid
      this.menu.objid = 0
      this.objMetaDataArr = []
      this.objPermissoes = []
      this.menu.objativo = true
      this.$root.$emit('bv::show::modal', 'editMenu')
    },
    editMenu: function (item, id = null) {
      this.titleModal = 'Editar Menu'
      this.menu = item
      this.objPermissoes = item.objpermissoes
      this.objparent = id === null ? 0 : id
      this.objMetaDataArr = item.objmetadataarr[0]
      this.$root.$emit('bv::show::modal', 'editMenu')
    },
    adicionandoMenu: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      var item = {
        objid: this.menu.objid,
        appid: this.objetoId,
        objhashcode: '123456',
        objnome: this.menu.objnome,
        objativo: this.menu.objativo,
        objparent: this.objparent,
        objtipID: 1,
        objordem: '99'
      }
      axios
        .post(
          this.baseUrlSeguranca + 'Objeto/adicionar',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          var id = response.data
          this.adicionandoObjetoParam(id)
          this.adicionandoPermissoes(id)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionandoObjetoParam: function (id) {
      var jsonMeta = {
        objicone: this.objMetaDataArr.objicone,
        objlink: this.objMetaDataArr.objlink,
        objtipomenu: 1
      }
      var item = {
        objid: id,
        objparamid: 0,
        objMetaData: JSON.stringify(jsonMeta)
      }
      axios
        .post(
          this.baseUrlSeguranca + 'Objeto/adicionarobjparam',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.menu = {}
          this.objMetaDataArr = {}
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editMenu')
          this.listandoObjetos()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editandoMenu: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      var editItem = {
        objnome: this.menu.objnome,
        objativo: this.menu.objativo,
        objparent: this.objparent,
        objordem: this.menu.objordem === null ? 0 : this.menu.objordem,
        objid: this.menu.objid,
        objtipID: 1,
        appid: this.objetoId,
        objhashcode: this.menu.objhashcode
      }
      axios
        .put(
          this.baseUrlSeguranca + 'Objeto/alterar',
          editItem,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.editandoObjetoParam(this.menu.objid)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    transferindoMenu(objId) {
      this.callConfirm('Deseja transferir o menu?', '').then(() => {
        this.carregaTexto('Copiando Menu')
        var data = {
          objID: objId,
          desenvHomolog: true,
          homologProducao: true
        }
        axios
          .post(
            this.baseUrlSeguranca + 'Menu/transferirmenus',
            data,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast(this.mensagensUpdate.adicionado, 'success')
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.callAlert('Erro', error.response.data, 'error', 'error')
            } else {
              this.setErrorSystem(error)
            }
          })
          .finally(this.carregaTexto)
      })
    },
    editandoObjetoParam: function (id) {
      var jsonMetaEdit = {
        objlink: this.objMetaDataArr.objlink,
        objicone: this.objMetaDataArr.objicone,
        objtipomenu: this.objMetaDataArr.objtipomenu
      }
      var item = {
        objid: id,
        objparamid: this.menu.objparamid,
        objMetaData: JSON.stringify(jsonMetaEdit)
      }
      axios
        .put(
          this.baseUrlSeguranca + 'Objeto/alterarobjparam',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoObjetos()
          this.menu = {}
          this.objMetaDataArr = {}
          this.objparent = ''
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editMenu')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoObjetoAcao: function () {
      axios
        .get(
          this.baseUrlSeguranca + 'Objeto/listarobjacaopermissao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaAcao = response.data
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoApp: function () {
      axios
        .get(
          this.baseUrlSeguranca + 'App/listarapp/' + this.objetoId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.titlePage = 'Menu: ' + response.data.appnome
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoObjetos: function (number = null) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Menu/listarmenuapp/' + this.objetoId,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaObjetos = response.data
          this.objetoFinal = []
          this.montandoObjeto(this.listaObjetos, number)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    montandoObjeto: function (lista, number = null) {
      for (var [key, listando] of Object.entries(lista)) {
        var lstCria = {
          text: listando.objnome,
          $folded: number !== null,
          ordem: key,
          objparent: 0,
          objativo: listando.objativo,
          item: listando,
          children: []
        }
        if (listando.objparent.length > 0) {
          for (var [keyNumber, lstParents] of Object.entries(listando.objparent)) {
            var lstChildren = this.capturaChildren(lstParents, lstCria, keyNumber, number)
            lstCria.children.push(lstChildren)
          }
        }
        this.objetoFinal.push(lstCria)
      }
      this.carregaTexto()
    },
    capturaChildren: function (lista, lstTotal, key, number = null) {
      var lstCria = {
        text: lista.objnome,
        objativo: lista.objativo,
        $folded: number !== null,
        objparent: lstTotal.item.objid,
        ordem: key,
        item: lista,
        children: []
      }
      if (lista.objparent !== undefined && lista.objparent !== null) {
        if (lista.objparent.length > 0) {
          for (var [keyNumber, lstParents] of Object.entries(lista.objparent)) {
            var lstChildren = this.capturaChildren(lstParents, lstCria, keyNumber)
            lstCria.children.push(lstChildren)
          }
        }
      }
      return lstCria
    }
  },
  computed: {
    lstObjetos() {
      return this.objetoFinal
    },
    lstObjetosAcao() {
      return this.listaAcao
    },
    lstPermissao() {
      return this.objPermissoes
    }
  },
  mounted: function () {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.objetoId = this.$route.params.id
    this.listandoObjetos(1)
    this.listandoApp()
    this.listandoObjetoAcao()
  }
}
</script>
